const defaultFontFamily = `'ARS Maquette Pro', regular`
const secondaryFontFamily = `'ARS Maquette Pro', regular`
const fontSize = 14 // px
const fontWeights = {
    light: 300,
    regular: 400,
    medium: 500,
    bold: 700,
}
const caseAllCaps = {
    textTransform: 'uppercase',
}
const htmlFontSize = 16 // 16px is the default font-size used by browsers.
const coef = fontSize / 14
const pxToRem = (size) => (size / htmlFontSize) * coef
const buildVariant = ({
    fontFamily = defaultFontFamily,
    fontWeight = fontWeights.regular,
    minSize,
    maxSize,
    lineHeight = 1.4,
    letterSpacing,
    casing = {},
}) => ({
    fontFamily,
    fontWeight,
    fontSize: `max(${
        minSize ?? pxToRem(maxSize)
    }rem, min(1rem + 16vw, ${pxToRem(maxSize)}rem))`,
    letterSpacing,
    lineHeight,
    ...casing,
})

const typography = {
    buttonSmall: buildVariant({
        fontFamily: secondaryFontFamily,
        fontWeight: fontWeights.bold,
        maxSize: 14,
        letterSpacing: 0.75,
    }),
    buttonMedium: buildVariant({
        fontFamily: secondaryFontFamily,
        fontWeight: fontWeights.bold,
        maxSize: 16,
        letterSpacing: 1,
    }),
    buttonBig: buildVariant({
        fontFamily: secondaryFontFamily,
        fontWeight: fontWeights.bold,
        maxSize: 18,
        letterSpacing: 1.25,
    }),
    fontWeights,
    pxToRem,
    defaultFontFamily,
    secondaryFontFamily,
    defaultFontSize: htmlFontSize,
    caseAllCaps,
}

export default typography
